import { Button } from "@/shared/components/ui/button";
import { ButtonLink } from "@/shared/components/ui/button-link";
import { TextLink } from "@/shared/components/ui/text-link";

export function ButtonShowcase() {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-wrap items-center gap-4">
        <Button type="button">Primário</Button>
        <Button type="button" variant="ghost">
          Fantasma
        </Button>
        <ButtonLink href="#" onClick={e => e.preventDefault()}>
          Como link (CTA)
        </ButtonLink>
      </div>
      <div className="flex flex-wrap gap-4">
        <TextLink to="/">Link interno</TextLink>
        <TextLink to="https://example.com" external>
          Link externo
        </TextLink>
      </div>
    </div>
  );
}
